import { LoginData } from './callLogin';
import { rpc } from './rpc';

export interface RefreshLoginParams {
  senha?: string;
}

export const callRefreshLogin = async (params: RefreshLoginParams) =>
  rpc<RefreshLoginParams, LoginData>('refresh_login_teclado', params);
